import styled from "styled-components";
import { primaryColor, thirdColor } from "../../styles/styles";

export const StyledTag = styled("span")`
  display: flex;
  align-items: center;
  align-self: flex-start; 
  gap: .6rem;
  background-color: ${thirdColor};
  padding: .55vw; 
  border-radius: 8px;
  border: 1px solid #404040;
  font-size: 100%;
  white-space: nowrap; 
` 